// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".switching-sidebar[data-v-397f17b7]{height:calc(100% - 54px)!important}@media(min-width:600px){.switching-sidebar[data-v-397f17b7]{height:100%!important}}.switching-sidebar__arrow[data-v-397f17b7]{transform:rotate(180deg);margin-right:5px}.switching-sidebar__content[data-v-397f17b7]{height:calc(100% - 48px);overflow-y:auto}@media(min-width:960px){.switching-sidebar__content[data-v-397f17b7]{height:calc(100% - 68px)}}", ""]);
// Exports
module.exports = exports;
